

export function getItem(key) {
  return localStorage.getItem(key);
}
export function setItem(key,Temporarytoken) {
  return localStorage.setItem(key,Temporarytoken);
}
export function removeItem(key) {
    localStorage.removeItem(key);
}

export function getItem1(key) {
  return localStorage.getItem(key);
}
export function setItem1(key,Temporarytoken) {
  return localStorage.setItem(key,Temporarytoken);
}
export function removeItem1(key) {
    localStorage.removeItem(key);
}


// WEBPACK FOOTER //
// ./src/components/utils/locstorage.js